import { Controller } from "@hotwired/stimulus"

// Dark-theme toggle. The <html> class is applied pre-paint by an inline
// script in the layout head; this controller flips it, persists the choice,
// and keeps aria-pressed accurate on every instance (header + footer can
// both render one, so state changes are broadcast).
export default class extends Controller {
  connect() {
    this.reflect = this.reflect.bind(this)
    window.addEventListener("theme:changed", this.reflect)
    this.reflect()
  }

  disconnect() {
    window.removeEventListener("theme:changed", this.reflect)
  }

  toggle() {
    const dark = !document.documentElement.classList.contains("dark")
    document.documentElement.classList.toggle("dark", dark)
    try { localStorage.setItem("theme", dark ? "dark" : "light") } catch {}
    window.dispatchEvent(new CustomEvent("theme:changed"))
  }

  reflect() {
    const dark = document.documentElement.classList.contains("dark")
    this.element.setAttribute("aria-pressed", String(dark))
  }
}
